<template>
  <div id="wrapper">
    <Nav :message="message" />
    <SpotCheck />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import SpotCheck from '@/components/profile/SpotCheck.vue'

export default {
  name: 'sc-spot-check',
  props: ['message'],
  components: {
    Nav,
    SpotCheck
  }
}
</script>